<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>

    <a class="logo" href="#" (click)="navigateHome()">کافینت ایران</a>
  </div>

  <div class="desktop-header-items">
    <ngx-connection-status></ngx-connection-status>

    <div class="wallet-chip" *ngIf="user?.balance !== undefined">
      <div (click)="handleRefresh()">
        <nb-icon
          icon="refresh"
          [class.rotate-icon]="isRefreshing"
        ></nb-icon>
        <span>موجودی:</span>
        <span><bdi dir="ltr">{{ user?.balance | number: '1.0-0' }}</bdi> تومان</span>
      </div>

      <div (click)="openCheckout()">
        <nb-icon icon="credit-card-outline"></nb-icon>
        <strong> برداشت</strong>
      </div>
    </div>

    <div class="operator-controls" *ngIf="hasRole('Operator')">
      <ngx-available-toggle></ngx-available-toggle>

      <button
        type="button"
        class="tab-sound-toggle"
        [class.tab-sound-toggle--muted]="isTabMuted"
        [attr.aria-pressed]="isTabMuted"
        [attr.aria-label]="
          isTabMuted
            ? 'فعال کردن صدای اعلان‌های این تب'
            : 'قطع کردن صدای اعلان‌های این تب'
        "
        [nbTooltip]="
          isTabMuted ? 'فعال کردن صدای این تب' : 'بی‌صدا کردن این تب'
        "
        (click)="toggleTabSound()"
      >
        <nb-icon
          [icon]="isTabMuted ? 'volume-off-outline' : 'volume-up-outline'"
        ></nb-icon>
        <span>{{ isTabMuted ? 'با صدا' : 'بی‌صدا' }}</span>
      </button>
    </div>

    <nb-icon
      class="mx-2"
      ghost
      [icon]="isDark ? 'moon-outline' : 'sun-outline'"
      (click)="toggleTheme()"
    ></nb-icon>
  </div>
</div>

<div class="header-container">
  <nb-actions size="small">
    <nb-action class="control-item">
      <!-- <nb-search type="rotate-layout"></nb-search> -->
    </nb-action>

    <nb-action class="control-item">
      <ngx-header-system-notifications></ngx-header-system-notifications>
    </nb-action>

    <nb-action class="control-item">
      <ngx-header-notifications></ngx-header-notifications>
    </nb-action>

    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <button
        type="button"
        class="profile-trigger"
        aria-label="منوی پروفایل"
        [nbContextMenu]="userMenu"
      >
        <span class="profile-avatar">
          <img
            *ngIf="user?.avatar?.url || user?.['picture']; else profileAvatarFallback"
            [src]="user?.avatar?.url || user?.['picture']"
            alt=""
          />
          <ng-template #profileAvatarFallback>
            <nb-icon icon="person-outline"></nb-icon>
          </ng-template>
        </span>

        <span class="profile-name">{{ user?.name || user?.firstName }}</span>

        <nb-icon
          class="profile-menu-icon"
          icon="chevron-down-outline"
        ></nb-icon>
      </button>
    </nb-action>
  </nb-actions>

  <button
    nbButton
    ghost
    class="mobile-header-menu-toggle"
    aria-label="منوی بیشتر"
    (click)="toggleMobileHeaderMenu()"
  >
    <nb-icon icon="more-vertical-outline"></nb-icon>
  </button>
</div>

<div class="mobile-header-menu" *ngIf="mobileHeaderMenuOpen">
  <div class="mobile-menu-item" *ngIf="user?.balance !== undefined">
    <div class="wallet-chip mobile-wallet">
      <div (click)="handleRefresh(); closeMobileHeaderMenu()">
        <nb-icon
          icon="refresh"
          [class.rotate-icon]="isRefreshing"
        ></nb-icon>
        <span>موجودی:</span>
        <span><bdi dir="ltr">{{ user?.balance | number: '1.0-0' }}</bdi> تومان</span>
      </div>

      <div (click)="openCheckout(); closeMobileHeaderMenu()">
        <nb-icon icon="credit-card-outline"></nb-icon>
        <strong>برداشت</strong>
      </div>
    </div>
  </div>

  <div class="mobile-menu-item gap-4" *ngIf="hasRole('Operator')">
    <ngx-available-toggle></ngx-available-toggle>
    <button
      type="button"
      class="tab-sound-toggle"
      [class.tab-sound-toggle--muted]="isTabMuted"
      [attr.aria-pressed]="isTabMuted"
      (click)="toggleTabSound()"
    >
      <nb-icon
        [icon]="isTabMuted ? 'volume-off-outline' : 'volume-up-outline'"
      ></nb-icon>
      <span>{{ isTabMuted ? 'با صدا' : 'بی‌صدا' }}</span>
    </button>
    <ngx-header-system-notifications></ngx-header-system-notifications>
    <ngx-header-notifications></ngx-header-notifications>
  </div>

  <div class="mobile-menu-item">
    <button
      type="button"
      nbButton
      ghost
      size="small"
      [attr.aria-label]="isDark ? 'فعال کردن حالت روشن' : 'فعال کردن حالت تاریک'"
      [attr.aria-pressed]="isDark"
      (click)="toggleTheme(); closeMobileHeaderMenu()"
    >
      <nb-icon [icon]="isDark ? 'moon-outline' : 'sun-outline'"></nb-icon>
      <span>{{ isDark ? 'حالت روشن' : 'حالت تاریک' }}</span>
    </button>
  </div>
</div>
